import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Nullable, Option } from '@types';
import { cleanHtmlValue } from '@utils';

const AutocompleteComponent = (props) => {
  const { schema, handleChange, form, testId = 'autocomplete' } = props;
  const { properties, options, inputProperties, key, defaultOption } = schema;
  const currentOption = form[key] ? form[key] : defaultOption;

  return (
    <Autocomplete
      {...properties}
      data-testid={testId}
      value={currentOption}
      onChange={(_event, option) => handleChange(option)}
      options={options}
      getOptionLabel={(option: Nullable<Option<string> | string>) =>
        typeof option === 'string' ? option : option?.label || ''
      }
      renderInput={(params) => (
        <TextField
          {...params}
          {...inputProperties}
          value={currentOption.value || currentOption}
          onChange={({ currentTarget }) => handleChange(cleanHtmlValue(currentTarget.value))}
        />
      )}
    />
  );
};

export { AutocompleteComponent };
